import {UserSource} from "../../tracking/tracking_utils/user_source";
import {UnlockChoiceEntryPoint} from "../types/UnlockChoiceEntryPoint";

const SIGN_UP_USER_SOURCES: UserSource[] = [UserSource.NAVIGATION, UserSource.REGISTRATION_GOOGLE_ONE_TAP_RP];

interface ISignUpRegistrationFlowState {
    userSource?: UserSource;
    unlockChoiceEntryPoint?: UnlockChoiceEntryPoint;
    useLeadAfterRegistration?: boolean;
}

export const isSignUpRegistrationFlow = ({userSource, unlockChoiceEntryPoint, useLeadAfterRegistration}: ISignUpRegistrationFlowState): boolean =>
    userSource !== undefined && SIGN_UP_USER_SOURCES.includes(userSource) && !unlockChoiceEntryPoint && !useLeadAfterRegistration;
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {UnlockChoiceEntryPoint} from "../types/UnlockChoiceEntryPoint";

const SIGN_UP_USER_SOURCES: UserSource[] = [UserSource.NAVIGATION, UserSource.REGISTRATION_GOOGLE_ONE_TAP_RP];

interface ISignUpRegistrationFlowState {
    userSource?: UserSource;
    unlockChoiceEntryPoint?: UnlockChoiceEntryPoint;
    useLeadAfterRegistration?: boolean;
}

export const isSignUpRegistrationFlow = ({userSource, unlockChoiceEntryPoint, useLeadAfterRegistration}: ISignUpRegistrationFlowState): boolean =>
    userSource !== undefined && SIGN_UP_USER_SOURCES.includes(userSource) && !unlockChoiceEntryPoint && !useLeadAfterRegistration;
